import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export const SOCIAL_FIELDS = [
  { key: "instagram", label: "Instagram", placeholder: "https://instagram.com/yourstore" },
  { key: "facebook", label: "Facebook", placeholder: "https://facebook.com/yourstore" },
  { key: "youtube", label: "YouTube", placeholder: "https://youtube.com/@yourstore" },
  { key: "twitter", label: "X / Twitter", placeholder: "https://x.com/yourstore" },
  { key: "website", label: "Website", placeholder: "https://yourstore.com" },
];

export const SocialSection = ({ form, setField }) => {
  const social = form.social || {};
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="whatsapp">WhatsApp Number</Label>
        <Input
          id="whatsapp"
          value={form.whatsapp || ""}
          onChange={(e) => setField("whatsapp", e.target.value)}
          placeholder="10-digit mobile (a chat button shows on your store)"
          className="mt-2"
          data-testid="store-whatsapp-input"
        />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {SOCIAL_FIELDS.map((f) => (
          <div key={f.key}>
            <Label htmlFor={`social-${f.key}`}>{f.label}</Label>
            <Input
              id={`social-${f.key}`}
              value={social[f.key] || ""}
              onChange={(e) => setField("social", { ...social, [f.key]: e.target.value })}
              placeholder={f.placeholder}
              className="mt-2"
              data-testid={`store-social-${f.key}-input`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
